import { Peripheral } from "../shared/Peripheral";
import type { ConnectionType } from "../shared/types";
import { PeripheralType } from "../shared/types";

export abstract class LabelPrinter extends Peripheral {
  constructor(connectionType: ConnectionType) {
    super(PeripheralType.labelPrinter, connectionType);
  }
  
  abstract print(bytes: Uint8Array): Promise<boolean>
}
